frappe.provide("xsuite.whitelabel");

const SKIP_TAGS = new Set([
	"SCRIPT",
	"STYLE",
	"NOSCRIPT",
	"TEXTAREA",
	"INPUT",
	"SELECT",
	"OPTION",
	"CODE",
	"PRE",
]);

const DOCUMENT_DATA_SELECTOR = [
	"[data-keep-brand-text]",
	".static-area",
	".control-value",
	".like-disabled-input",
	".ace_editor",
	"[contenteditable='true']",
].join(", ");

xsuite.whitelabel.get_branding = function () {
	return frappe.boot?.xsuite_branding || {};
};

xsuite.whitelabel.is_enabled = function () {
	return Boolean(xsuite.whitelabel.get_branding().enabled);
};

xsuite.whitelabel.get_replacements = function () {
	const branding = xsuite.whitelabel.get_branding();
	if (!branding.replace_brand_text) return [];
	return (branding.text_replacements || []).filter((row) => row.find);
};

xsuite.whitelabel.replace_text = function (text) {
	if (!text || typeof text !== "string") return text;
	for (const row of xsuite.whitelabel.get_replacements()) {
		if (text.includes(row.find)) {
			text = text.split(row.find).join(row.replace || "");
		}
	}
	return text;
};

xsuite.whitelabel.needs_replacement = function (text) {
	if (!text) return false;
	return xsuite.whitelabel.get_replacements().some((row) => text.includes(row.find));
};

xsuite.whitelabel.sweep_node = function (node) {
	if (!node) return;

	if (node.nodeType === Node.TEXT_NODE) {
		rewrite_text_node(node);
		return;
	}

	if (node.nodeType !== Node.ELEMENT_NODE) return;
	if (SKIP_TAGS.has(node.nodeName) || node.closest?.(DOCUMENT_DATA_SELECTOR)) return;

	const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
		acceptNode(text_node) {
			return SKIP_TAGS.has(text_node.parentNode?.nodeName)
				? NodeFilter.FILTER_REJECT
				: NodeFilter.FILTER_ACCEPT;
		},
	});

	const pending = [];
	while (walker.nextNode()) {
		pending.push(walker.currentNode);
	}
	pending.forEach(rewrite_text_node);

	if (node.title && xsuite.whitelabel.needs_replacement(node.title)) {
		node.title = xsuite.whitelabel.replace_text(node.title);
	}
};

function rewrite_text_node(text_node) {
	if (SKIP_TAGS.has(text_node.parentNode?.nodeName)) return;
	if (!xsuite.whitelabel.needs_replacement(text_node.nodeValue)) return;
	if (text_node.parentElement?.closest(DOCUMENT_DATA_SELECTOR)) return;
	text_node.nodeValue = xsuite.whitelabel.replace_text(text_node.nodeValue);
}

xsuite.whitelabel.patch_translations = function () {
	if (!xsuite.whitelabel.get_replacements().length) return;
	if (frappe._xsuite_translate_patched) return;

	const translate = frappe._;
	frappe._ = function (txt, replace, context) {
		return xsuite.whitelabel.replace_text(translate.call(this, txt, replace, context));
	};
	window.__ = frappe._;
	frappe._xsuite_translate_patched = true;
};

xsuite.whitelabel.observe_dom = function () {
	if (!xsuite.whitelabel.get_replacements().length) return;
	if (xsuite.whitelabel.observer) return;

	let queued = [];
	let scheduled = false;

	const flush = () => {
		scheduled = false;
		const nodes = queued;
		queued = [];
		nodes.forEach(xsuite.whitelabel.sweep_node);
	};

	xsuite.whitelabel.observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (mutation.type === "characterData") {
				queued.push(mutation.target);
			} else {
				mutation.addedNodes.forEach((node) => queued.push(node));
			}
		}
		if (queued.length && !scheduled) {
			scheduled = true;
			requestAnimationFrame(flush);
		}
	});

	xsuite.whitelabel.observer.observe(document.body, {
		childList: true,
		characterData: true,
		subtree: true,
	});

	xsuite.whitelabel.sweep_node(document.body);
};

xsuite.whitelabel.apply_favicon = function () {
	const branding = xsuite.whitelabel.get_branding();
	const favicon = branding.favicon || branding.app_logo;
	if (!favicon) return;

	document.querySelectorAll("link[rel~='icon']").forEach((link) => {
		link.href = favicon;
	});
};

export default xsuite.whitelabel;
